import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";


const Main = lazy(() => import("../components/overview/main"));

const Overview = () => {
  return (
    // <Layout>
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    // </Layout>
  );
};

export default Overview;
